// extracted by mini-css-extract-plugin
export default {"toggleButton":"ToggleButton_toggleButton__xeKxu","styles":"ToggleButton_styles__WheFD","icon":"ToggleButton_icon__xWMup"};